
  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho

  $('#right-upc input, #left-upc input').val(val_upc);
	
$('#left-graduacion').click(function() {
    var_l_sph = $('#8060384280770_option_4').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-graduacion').click(function() {
    var_r_sph = $('#8060384280770_option_5').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}

function fetch_sku_l(){
 	switch (sku_values_l) { 
case '+8.00' : $('#left-sku input').val('730822253925'); break;
case '+7.50' : $('#left-sku input').val('730822253932'); break;
case '+7.00' : $('#left-sku input').val('730822253949'); break;
case '+6.50' : $('#left-sku input').val('730822253956'); break;
case '+6.00' : $('#left-sku input').val('730822253963'); break;
case '+5.75' : $('#left-sku input').val('730822253970'); break;
case '+5.50' : $('#left-sku input').val('730822253987'); break;
case '+5.25' : $('#left-sku input').val('730822253994'); break;
case '+5.00' : $('#left-sku input').val('730822254007'); break;
case '+4.75' : $('#left-sku input').val('730822254014'); break;
case '+4.50' : $('#left-sku input').val('730822254021'); break;
case '+4.25' : $('#left-sku input').val('730822254038'); break;
case '+4.00' : $('#left-sku input').val('730822254045'); break;
case '+3.75' : $('#left-sku input').val('730822254052'); break;
case '+3.50' : $('#left-sku input').val('730822254069'); break;
case '+3.25' : $('#left-sku input').val('730822254076'); break;
case '+3.00' : $('#left-sku input').val('730822254083'); break;
case '+2.75' : $('#left-sku input').val('730822254090'); break;
case '+2.50' : $('#left-sku input').val('730822254106'); break;
case '+2.25' : $('#left-sku input').val('730822254113'); break;
case '+2.00' : $('#left-sku input').val('730822254120'); break;
case '+1.75' : $('#left-sku input').val('730822254137'); break;
case '+1.50' : $('#left-sku input').val('730822254144'); break;
case '+1.25' : $('#left-sku input').val('730822254151'); break;
case '+1.00' : $('#left-sku input').val('730822254168'); break;
case '+0.75' : $('#left-sku input').val('730822254175'); break;
case '+0.50' : $('#left-sku input').val('730822254182'); break;
case '-0.50' : $('#left-sku input').val('730822254199'); break;
case '-0.75' : $('#left-sku input').val('730822254205'); break;
case '-1.00' : $('#left-sku input').val('730822254212'); break;
case '-1.25' : $('#left-sku input').val('730822254229'); break;
case '-1.50' : $('#left-sku input').val('730822254236'); break;
case '-1.75' : $('#left-sku input').val('730822254243'); break;
case '-2.00' : $('#left-sku input').val('730822254250'); break;
case '-2.25' : $('#left-sku input').val('730822254267'); break;
case '-2.50' : $('#left-sku input').val('730822254274'); break;
case '-2.75' : $('#left-sku input').val('730822254281'); break;
case '-3.00' : $('#left-sku input').val('730822254298'); break;
case '-3.25' : $('#left-sku input').val('730822254304'); break;
case '-3.50' : $('#left-sku input').val('730822254311'); break;
case '-3.75' : $('#left-sku input').val('730822254328'); break;
case '-4.00' : $('#left-sku input').val('730822254335'); break;
case '-4.25' : $('#left-sku input').val('730822254342'); break;
case '-4.50' : $('#left-sku input').val('730822254359'); break;
case '-4.75' : $('#left-sku input').val('730822254366'); break;
case '-5.00' : $('#left-sku input').val('730822254373'); break;
case '-5.25' : $('#left-sku input').val('730822254380'); break;
case '-5.50' : $('#left-sku input').val('730822254397'); break;
case '-5.75' : $('#left-sku input').val('730822254403'); break;
case '-6.00' : $('#left-sku input').val('730822254410'); break;
case '-6.50' : $('#left-sku input').val('730822254427'); break;
case '-7.00' : $('#left-sku input').val('730822254434'); break;
case '-7.50' : $('#left-sku input').val('730822254441'); break;
case '-8.00' : $('#left-sku input').val('730822254458'); break;
case '-8.50' : $('#left-sku input').val('730822254465'); break;
case '-9.00' : $('#left-sku input').val('730822254472'); break;
case '-9.50' : $('#left-sku input').val('730822254489'); break;
case '-10.00' : $('#left-sku input').val('730822254496'); break;
case '-10.50' : $('#left-sku input').val('730822254502'); break;
case '-11.00' : $('#left-sku input').val('730822254519'); break;
case '-11.50' : $('#left-sku input').val('730822254526'); break;
case '-12.00' : $('#left-sku input').val('730822254533'); break;



 	    default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()

function fetch_sku_r(){
 	switch (sku_values_r) {
case '+8.00' : $('#right-sku input').val('730822253925'); break;
case '+7.50' : $('#right-sku input').val('730822253932'); break;
case '+7.00' : $('#right-sku input').val('730822253949'); break;
case '+6.50' : $('#right-sku input').val('730822253956'); break;
case '+6.00' : $('#right-sku input').val('730822253963'); break;
case '+5.75' : $('#right-sku input').val('730822253970'); break;
case '+5.50' : $('#right-sku input').val('730822253987'); break;
case '+5.25' : $('#right-sku input').val('730822253994'); break;
case '+5.00' : $('#right-sku input').val('730822254007'); break;
case '+4.75' : $('#right-sku input').val('730822254014'); break;
case '+4.50' : $('#right-sku input').val('730822254021'); break;
case '+4.25' : $('#right-sku input').val('730822254038'); break;
case '+4.00' : $('#right-sku input').val('730822254045'); break;
case '+3.75' : $('#right-sku input').val('730822254052'); break;
case '+3.50' : $('#right-sku input').val('730822254069'); break;
case '+3.25' : $('#right-sku input').val('730822254076'); break;
case '+3.00' : $('#right-sku input').val('730822254083'); break;
case '+2.75' : $('#right-sku input').val('730822254090'); break;
case '+2.50' : $('#right-sku input').val('730822254106'); break;
case '+2.25' : $('#right-sku input').val('730822254113'); break;
case '+2.00' : $('#right-sku input').val('730822254120'); break;
case '+1.75' : $('#right-sku input').val('730822254137'); break;
case '+1.50' : $('#right-sku input').val('730822254144'); break;
case '+1.25' : $('#right-sku input').val('730822254151'); break;
case '+1.00' : $('#right-sku input').val('730822254168'); break;
case '+0.75' : $('#right-sku input').val('730822254175'); break;
case '+0.50' : $('#right-sku input').val('730822254182'); break;
case '-0.50' : $('#right-sku input').val('730822254199'); break;
case '-0.75' : $('#right-sku input').val('730822254205'); break;
case '-1.00' : $('#right-sku input').val('730822254212'); break;
case '-1.25' : $('#right-sku input').val('730822254229'); break;
case '-1.50' : $('#right-sku input').val('730822254236'); break;
case '-1.75' : $('#right-sku input').val('730822254243'); break;
case '-2.00' : $('#right-sku input').val('730822254250'); break;
case '-2.25' : $('#right-sku input').val('730822254267'); break;
case '-2.50' : $('#right-sku input').val('730822254274'); break;
case '-2.75' : $('#right-sku input').val('730822254281'); break;
case '-3.00' : $('#right-sku input').val('730822254298'); break;
case '-3.25' : $('#right-sku input').val('730822254304'); break;
case '-3.50' : $('#right-sku input').val('730822254311'); break;
case '-3.75' : $('#right-sku input').val('730822254328'); break;
case '-4.00' : $('#right-sku input').val('730822254335'); break;
case '-4.25' : $('#right-sku input').val('730822254342'); break;
case '-4.50' : $('#right-sku input').val('730822254359'); break;
case '-4.75' : $('#right-sku input').val('730822254366'); break;
case '-5.00' : $('#right-sku input').val('730822254373'); break;
case '-5.25' : $('#right-sku input').val('730822254380'); break;
case '-5.50' : $('#right-sku input').val('730822254397'); break;
case '-5.75' : $('#right-sku input').val('730822254403'); break;
case '-6.00' : $('#right-sku input').val('730822254410'); break;
case '-6.50' : $('#right-sku input').val('730822254427'); break;
case '-7.00' : $('#right-sku input').val('730822254434'); break;
case '-7.50' : $('#right-sku input').val('730822254441'); break;
case '-8.00' : $('#right-sku input').val('730822254458'); break;
case '-8.50' : $('#right-sku input').val('730822254465'); break;
case '-9.00' : $('#right-sku input').val('730822254472'); break;
case '-9.50' : $('#right-sku input').val('730822254489'); break;
case '-10.00' : $('#right-sku input').val('730822254496'); break;
case '-10.50' : $('#right-sku input').val('730822254502'); break;
case '-11.00' : $('#right-sku input').val('730822254519'); break;
case '-11.50' : $('#right-sku input').val('730822254526'); break;
case '-12.00' : $('#right-sku input').val('730822254533'); break;


 		default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()
